import { IContactFormDataForAPI, IContactPayloadForAPI } from 'src/utils/CommonHelpers/ContactAPIOperations/types';
import {
  addCalendarFields,
  addHomePropertyFields,
  addOccupantFields,
  addRealtorFields,
  addServiceManagerFields,
  addServiceProviderFields,
  addFieldsForUsersThatNeedACompanyName,
  createBasePayload,
} from 'src/utils/CommonHelpers/ContactAPIOperations/sharedContactPayloadBuilderHelpers';
import { UserRole } from 'src/SharedCustomHooks/UseSuiteActions/types';

const buildContactsPayloadContactsPage = (
  formData: IContactFormDataForAPI,
  adminUserId: any,
  allRoles: UserRole[] | null | undefined
): IContactPayloadForAPI => {
  // Start with base payload
  let payload: Partial<IContactPayloadForAPI> = createBasePayload(
    formData,
    adminUserId,
    allRoles,
    'Contacts'
  );
  
  payload = addServiceProviderFields(payload, formData);
  payload = addHomePropertyFields(payload, formData);
  payload = addRealtorFields(payload, formData);
  payload = addOccupantFields(payload, formData);
  payload = addServiceManagerFields(payload, formData);
  payload = addCalendarFields(payload, formData);
  payload = addFieldsForUsersThatNeedACompanyName(payload, formData)
  
  // TODO: Temporary workaround - remove when API is fixed
  // https://app.asana.com/1/41213529744312/project/1208712340140532/task/1211760218229163
  delete payload.isPrimaryPropertyDeveloperContact;
  delete payload.IsPrimaryContact;
  
  return payload as IContactPayloadForAPI;
};

export { buildContactsPayloadContactsPage }